const DarkThemeColors = [
  {
    name: 'RED_THEME',
    palette: {
      primary: {
        main: '#CC0000',
        light: '#4D1A1A',
        dark: '#990000',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#49BEFF',
        light: '#4D1A1A',
        dark: '#23afdb',
        contrastText: '#ffffff',
      },
      background: {
        default: '#171c23',
        dark: '#171c23',
        paper: '#171c23',
      },
    },
  },
];

export { DarkThemeColors };